import { Component, OnInit, Input } from '@angular/core';
import { ContactService } from '../../services/contact.service';
import { EmployeeService } from '../../services/employees.service';
import { OrderService } from '../../services/order.service';
import { UtilService } from '../../services/util.service';
import { Employee, OrderEventType, QuoteOrderEventNotification, SearchCustomerContact } from '../../models/models';
import { forkJoin } from 'rxjs';

@Component({
    selector: 'quoteorder-event-notification-form',
    templateUrl: './quoteorder-event-notification-form.component.html',
    standalone: false
})
export class QuoteOrderEventNotificationForm implements OnInit {
    @Input() quoteOrderID: number = 0;
    @Input() customerID: number = 0;

    public quoteOrderEventNotification: QuoteOrderEventNotification = {} as QuoteOrderEventNotification;
    public orderEventTypeList: OrderEventType[] = [];
    public contactList: SearchCustomerContact[] = [];
    public employeeList: Employee[] = [];
    public emails: string[] = [];
    public selectedContacts: SearchCustomerContact[] = [];
    public selectedEmployees: Employee[] = [];
    public isAll: boolean = false;
    public isAllArv: boolean = false;
    public isAllDep: boolean = false;
    public selectedEventTypeList: number[] = [];

    constructor(public contactService: ContactService, public employeeService: EmployeeService,
        private orderService: OrderService, private utilService: UtilService) {
    }

    ngOnInit() {
        var getQuotOrderEventNotification = this.orderService.getQuoteOrderEventNotificationByQuoteOrderID(this.quoteOrderID);
        var getOrderEventTypes = this.orderService.getOrderEventTypes();
        var getContacts = this.contactService.getSearchContactByCustomerID(this.customerID);
        var getEmployees = this.employeeService.getActiveEmployees();

        this.utilService.isLoading = true;

        forkJoin([getOrderEventTypes, getContacts, getEmployees, getQuotOrderEventNotification]).subscribe(result => {
            this.utilService.isLoading = false;

            this.orderEventTypeList = result[0].resultCollection;
            this.orderEventTypeList = this.orderEventTypeList.filter(t => t.isEventNotification == true);

            this.contactList = result[1].resultCollection;
            this.contactList = this.contactList.filter(t => t.email != null && t.email != "");

            this.employeeList = result[2];
            this.employeeList = this.employeeList.filter(t => t.email != null && t.email != "");

            this.setQuotOrderEventNotification(result[3]);
        });
    }

    private setQuotOrderEventNotification(result) {
        if (result.resultCollection.length > 0) {
            this.quoteOrderEventNotification = result.resultCollection[0];
            var contactList = this.quoteOrderEventNotification.customerContactIDList.split(",");
            var employeeList = this.quoteOrderEventNotification.employeeIDList.split(",");
            var typeList = this.quoteOrderEventNotification.orderEventTypeIDList.split(",");
            this.selectedContacts = [];
            this.selectedEmployees = [];
            this.selectedEventTypeList = [];
            for (var i = 0; i < contactList.length; i++) {
                var contact = this.contactList.find(t => t.contactID == parseInt(contactList[i]));
                if (contact != null) {
                    this.selectedContacts.push(contact);
                }
            }
            for (var i = 0; i < employeeList.length; i++) {
                var employee = this.employeeList.find(t => t.employeeId == parseInt(employeeList[i]));
                if (employee != null) {
                    this.selectedEmployees.push(employee);
                }
            }
            for (var i = 0; i < typeList.length; i++) {
                this.selectedEventTypeList.push(parseInt(typeList[i]));
            }
            console.log("getQuotOrderEventNotification:update", this.quoteOrderEventNotification, this.selectedContacts, this.selectedEmployees, contactList, employeeList);
        }
        else {
            this.quoteOrderEventNotification = {} as QuoteOrderEventNotification;
            this.quoteOrderEventNotification.quoteOrderEventNotificationID = 0;
            this.quoteOrderEventNotification.quoteOrderID = this.quoteOrderID;
            this.quoteOrderEventNotification.orderEventTypeIDList = "";
            this.quoteOrderEventNotification.customerContactIDList = "";
            this.quoteOrderEventNotification.employeeIDList = "";
            this.quoteOrderEventNotification.additionalEmails = "";
            this.quoteOrderEventNotification.createdByEmployeeID = parseInt(localStorage.getItem('EmployeeId')!);
        }
        console.log("getQuotOrderEventNotification", this.quoteOrderEventNotification, this.selectedContacts, this.selectedEmployees);
    }

    public saveQuotOrderEventNotification() {
        this.utilService.isLoading = true;
        var contactIDList = "";
        var employeeIDList = "";
        for (var i = 0; i < this.selectedContacts.length; i++) {
            if (i > 0) {
                contactIDList += ",";
            }
            contactIDList += this.selectedContacts[i].contactID;
        }
        for (var i = 0; i < this.selectedEmployees.length; i++) {
            if (i > 0) {
                employeeIDList += ",";
            }
            employeeIDList += this.selectedEmployees[i].employeeId;
        }
        this.quoteOrderEventNotification.customerContactIDList = contactIDList;
        this.quoteOrderEventNotification.employeeIDList = employeeIDList;
        this.quoteOrderEventNotification.lastModifiedByEmployeeID = parseInt(localStorage.getItem('EmployeeId')!);
        this.quoteOrderEventNotification.orderEventTypeIDList = this.selectedEventTypeList.join(",");
        this.orderService.saveQuoteOrderEventNotification(this.quoteOrderEventNotification).subscribe(result => {
            this.utilService.isLoading = false;
            this.quoteOrderEventNotification = result.resultCollection[0];
            this.orderService.getQuoteOrderEventNotificationByQuoteOrderID(this.quoteOrderID).subscribe(result => {
                this.setQuotOrderEventNotification(result);
            });
            console.log("saveQuoteOrderEventNotification", contactIDList, employeeIDList, this.quoteOrderEventNotification);
        });
    }

    public eventTypeAllClick(allType: string) {
        if (allType == "All") {
            this.isAll = !this.isAll;
            this.isAllArv = false;
            this.isAllDep = false;
            this.selectedEventTypeList = [];
            if (this.isAll) {
                for (var i = 0; i < this.orderEventTypeList.length; i++) {
                    this.selectedEventTypeList.push(this.orderEventTypeList[i].orderEventTypeID);
                }
            }
        }
        else if (allType == "Arv") {
            this.isAll = false;
            this.isAllDep = false;
            this.isAllArv = !this.isAllArv;
            this.selectedEventTypeList = [];
            if (this.isAllArv) {
                var typeList = this.orderEventTypeList.filter(t => t.code.indexOf("-Arv") >= 0);
                for (var i = 0; i < typeList.length; i++) {
                    this.selectedEventTypeList.push(typeList[i].orderEventTypeID);
                }
            }
        }
        else if (allType == "Dep") {
            this.isAll = false;
            this.isAllArv = false;
            this.isAllDep = !this.isAllDep;
            this.selectedEventTypeList = [];
            if (this.isAllDep) {
                var typeList = this.orderEventTypeList.filter(t => t.code.indexOf("-Dep") >= 0);
                for (var i = 0; i < typeList.length; i++) {
                    this.selectedEventTypeList.push(typeList[i].orderEventTypeID);
                }
            }
        }
        //console.log("eventTypeAllClick", allType, this.selectedEventTypeList);
    }

    public eventTypeClick(eventType: OrderEventType) {
        this.isAll = false;
        this.isAllArv = false;
        this.isAllDep = false;
        if (this.selectedEventTypeList.indexOf(eventType.orderEventTypeID) < 0) {
            this.selectedEventTypeList.push(eventType.orderEventTypeID);
        }
        else {
            var idx = this.selectedEventTypeList.indexOf(eventType.orderEventTypeID);
            this.selectedEventTypeList.splice(idx, 1);
        }
        //console.log("eventTypeClick", eventType.orderEventTypeID, this.selectedEventTypeList);
    }

    public isEventChecked(eventType: OrderEventType) {
        if (this.selectedEventTypeList.indexOf(eventType.orderEventTypeID) >= 0) {
            return true;
        }
        else {
            return false;
        }
    }
}
